import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "my-listings-container w-full" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "flex border-b border-gray-700 mb-6" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "w-full"
}
const _hoisted_7 = {
  key: 0,
  class: "py-12 flex justify-center"
}
const _hoisted_8 = {
  key: 1,
  class: "py-12 text-center"
}
const _hoisted_9 = { class: "text-red-400 mb-4" }
const _hoisted_10 = {
  key: 2,
  class: "py-12 text-center text-white"
}
const _hoisted_11 = {
  key: 3,
  class: "space-y-6"
}
const _hoisted_12 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full max-w-6xl mx-auto" }
const _hoisted_13 = { class: "absolute top-2 right-2 z-10" }
const _hoisted_14 = {
  key: 1,
  class: "w-full"
}
const _hoisted_15 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_16 = {
  key: 1,
  class: "mb-6"
}
const _hoisted_17 = {
  key: 0,
  class: "bg-red-900/30 border border-red-500 rounded-lg p-4 mb-6"
}
const _hoisted_18 = { class: "flex items-start" }
const _hoisted_19 = { class: "text-red-300 text-sm" }
const _hoisted_20 = {
  key: 1,
  class: "bg-red-900/30 border border-red-500 rounded-lg p-4 mb-6"
}
const _hoisted_21 = { class: "flex items-start" }
const _hoisted_22 = { class: "text-red-300 text-sm" }
const _hoisted_23 = {
  key: 2,
  class: "bg-yellow-900/30 border border-yellow-500 rounded-lg p-4 mb-6"
}
const _hoisted_24 = { class: "flex items-start" }
const _hoisted_25 = { class: "text-yellow-300 text-sm" }
const _hoisted_26 = {
  key: 2,
  class: "py-12 flex justify-center"
}
const _hoisted_27 = {
  key: 3,
  class: "py-12 text-center"
}
const _hoisted_28 = { class: "text-red-400 mb-4" }
const _hoisted_29 = {
  key: 4,
  class: "py-12 text-center text-white"
}
const _hoisted_30 = {
  key: 5,
  class: "space-y-6"
}
const _hoisted_31 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full max-w-6xl mx-auto" }
const _hoisted_32 = { class: "absolute top-2 right-2 z-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ProductManageActions = _resolveComponent("ProductManageActions")!
  const _component_ProductCard = _resolveComponent("ProductCard")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_ConfirmationModal = _resolveComponent("ConfirmationModal")!
  const _component_ToastNotification = _resolveComponent("ToastNotification")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "mb-6" }, [
      _createElementVNode("h1", { class: "text-2xl font-bold text-white mb-2" }, "Moji oglasi"),
      _createElementVNode("p", { class: "text-gray-400" }, " Pregledajte i upravljajte svojim aktivnim i neaktivnim oglasima ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/create-product",
        class: "inline-flex items-center px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded font-medium transition-colors"
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "h-5 w-5 mr-2",
            viewBox: "0 0 20 20",
            fill: "currentColor"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
              "clip-rule": "evenodd"
            })
          ], -1),
          _createTextVNode(" Dodaj novi oglas ")
        ])),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
          return (_openBlock(), _createElementBlock("button", {
            key: tab.id,
            onClick: ($event: any) => (_ctx.setActiveTab(tab.id)),
            class: _normalizeClass(["px-6 py-3 text-sm font-medium transition-colors relative -mb-px", [
            _ctx.activeTab === tab.id
              ? 'text-blue-400 border-b-2 border-blue-400'
              : 'text-gray-400 hover:text-gray-300',
          ]])
          }, [
            _createTextVNode(_toDisplayString(tab.label) + " ", 1),
            (tab.count !== undefined)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["ml-2 px-2 py-0.5 text-xs rounded-full", 
              _ctx.activeTab === tab.id
                ? 'bg-blue-900 text-blue-200'
                : 'bg-gray-700 text-gray-300'
            ])
                }, _toDisplayString(tab.count), 3))
              : _createCommentVNode("", true)
          ], 10, _hoisted_5))
        }), 128))
      ]),
      (_ctx.activeTab === 'active')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.showActiveLoader)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[6] || (_cache[6] = [
                  _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500" }, null, -1)
                ])))
              : (_ctx.errorActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.errorActive), 1),
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fetchActiveProducts(_ctx.activeCurrentPage))),
                      class: "px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
                    }, " Pokušaj ponovo ")
                  ]))
                : (_ctx.activeProducts.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _cache[8] || (_cache[8] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-16 w-16 mx-auto mb-4 text-gray-600",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                        })
                      ], -1)),
                      _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-lg font-medium mb-2" }, "Nemate aktivnih oglasa", -1)),
                      _cache[10] || (_cache[10] = _createElementVNode("p", { class: "mb-4" }, "Kreirajte novi oglas da biste počeli sa prodajom", -1)),
                      _createVNode(_component_router_link, {
                        to: "/create-product",
                        class: "inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
                      }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            class: "h-5 w-5 mr-2",
                            viewBox: "0 0 20 20",
                            fill: "currentColor"
                          }, [
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
                              "clip-rule": "evenodd"
                            })
                          ], -1),
                          _createTextVNode(" Dodaj novi oglas ")
                        ])),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeProducts, (product) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: product.id,
                            class: "relative"
                          }, [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_ProductManageActions, {
                                "is-active": true,
                                onEdit: ($event: any) => (_ctx.navigateToEdit(product.id)),
                                onDelete: ($event: any) => (_ctx.openDeleteModal(product, true))
                              }, null, 8, ["onEdit", "onDelete"])
                            ]),
                            _createVNode(_component_ProductCard, {
                              product: product,
                              "show-follow-button": false
                            }, null, 8, ["product"])
                          ]))
                        }), 128))
                      ]),
                      _createVNode(_component_PaginationComponent, {
                        meta: _ctx.activeMeta,
                        "current-page": _ctx.activeCurrentPage,
                        "update-url": true,
                        onPageChange: _ctx.handleActivePageChange
                      }, null, 8, ["meta", "current-page", "onPageChange"])
                    ]))
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === 'inactive')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (_ctx.isLoadingStats)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[11] || (_cache[11] = [
                  _createElementVNode("div", { class: "bg-gray-800 rounded-lg p-4 flex items-center justify-center" }, [
                    _createElementVNode("div", { class: "animate-spin rounded-full h-5 w-5 border-b-2 border-blue-500 mr-3" }),
                    _createElementVNode("span", { class: "text-gray-400" }, "Proverava se broj aktivnih oglasa...")
                  ], -1)
                ])))
              : _createCommentVNode("", true),
            (!_ctx.isLoadingStats)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  (_ctx.userStats.remainingSlots === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _cache[16] || (_cache[16] = _createElementVNode("svg", {
                            class: "w-5 h-5 text-red-400 mt-0.5 mr-3 flex-shrink-0",
                            fill: "currentColor",
                            viewBox: "0 0 20 20"
                          }, [
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                              "clip-rule": "evenodd"
                            })
                          ], -1)),
                          _createElementVNode("div", null, [
                            _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "text-red-400 font-medium mb-1" }, " Dostigli ste maksimalan broj aktivnih besplatnih oglasa ", -1)),
                            _createElementVNode("p", _hoisted_19, [
                              _cache[12] || (_cache[12] = _createTextVNode(" Trenutno imate ")),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.userStats.activeProductsCount), 1),
                              _cache[13] || (_cache[13] = _createTextVNode(" od ")),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.userStats.maxProductsAllowed), 1),
                              _cache[14] || (_cache[14] = _createTextVNode(" dozvoljenih aktivnih besplatnih oglasa. Da biste obnovili neki oglas, sačekajte da neki postojeći istekne ili ga ručno obrišite. "))
                            ])
                          ])
                        ])
                      ]))
                    : (
              _ctx.userStats.remainingSlots > 0 && _ctx.userStats.remainingSlots < 20
            )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _cache[21] || (_cache[21] = _createElementVNode("svg", {
                              class: "w-5 h-5 text-red-400 mt-0.5 mr-3 flex-shrink-0",
                              fill: "currentColor",
                              viewBox: "0 0 20 20"
                            }, [
                              _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                                "clip-rule": "evenodd"
                              })
                            ], -1)),
                            _createElementVNode("div", null, [
                              _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "text-red-400 font-medium mb-1" }, " Kritično malo preostalih besplatnih oglasa ", -1)),
                              _createElementVNode("p", _hoisted_22, [
                                _cache[17] || (_cache[17] = _createTextVNode(" Možete obnoviti još samo ")),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.userStats.remainingSlots), 1),
                                _cache[18] || (_cache[18] = _createTextVNode(" oglasa. Trenutno imate ")),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.userStats.activeProductsCount), 1),
                                _cache[19] || (_cache[19] = _createTextVNode(" aktivnih besplatnih oglasa. "))
                              ])
                            ])
                          ])
                        ]))
                      : (
              _ctx.userStats.remainingSlots >= 20 && _ctx.userStats.remainingSlots < 40
            )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _cache[26] || (_cache[26] = _createElementVNode("svg", {
                                class: "w-5 h-5 text-yellow-400 mt-0.5 mr-3 flex-shrink-0",
                                fill: "currentColor",
                                viewBox: "0 0 20 20"
                              }, [
                                _createElementVNode("path", {
                                  "fill-rule": "evenodd",
                                  d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                                  "clip-rule": "evenodd"
                                })
                              ], -1)),
                              _createElementVNode("div", null, [
                                _cache[25] || (_cache[25] = _createElementVNode("h3", { class: "text-yellow-400 font-medium mb-1" }, " Približavate se limitu maksimalnog broja besplatnih oglasa ", -1)),
                                _createElementVNode("p", _hoisted_25, [
                                  _cache[22] || (_cache[22] = _createTextVNode(" Možete obnoviti još ")),
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.userStats.remainingSlots), 1),
                                  _cache[23] || (_cache[23] = _createTextVNode(" oglasa. Trenutno imate ")),
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.userStats.activeProductsCount), 1),
                                  _cache[24] || (_cache[24] = _createTextVNode(" aktivnih besplatnih oglasa. "))
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.showInactiveLoader)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, _cache[27] || (_cache[27] = [
                  _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500" }, null, -1)
                ])))
              : (_ctx.errorInactive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.errorInactive), 1),
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fetchInactiveProducts(_ctx.inactiveCurrentPage))),
                      class: "px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
                    }, " Pokušaj ponovo ")
                  ]))
                : (_ctx.inactiveProducts.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[28] || (_cache[28] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-16 w-16 mx-auto mb-4 text-gray-600",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
                        })
                      ], -1),
                      _createElementVNode("p", { class: "text-lg font-medium mb-2" }, "Nemate neaktivnih oglasa", -1),
                      _createElementVNode("p", null, " Ovde će se prikazati vaši oglasi kojima je istekao period aktivnosti ", -1)
                    ])))
                  : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inactiveProducts, (product) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: product.id,
                            class: "relative"
                          }, [
                            _createElementVNode("div", _hoisted_32, [
                              _createVNode(_component_ProductManageActions, {
                                "is-active": false,
                                "can-renew": _ctx.userStats.remainingSlots > 0,
                                onRenew: ($event: any) => (_ctx.openRenewModal(product)),
                                onDelete: ($event: any) => (_ctx.openDeleteModal(product, false))
                              }, null, 8, ["can-renew", "onRenew", "onDelete"])
                            ]),
                            _createVNode(_component_ProductCard, {
                              product: product,
                              "show-follow-button": false
                            }, null, 8, ["product"]),
                            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "absolute top-0 left-0 m-2 px-2 py-1 bg-red-900 text-red-200 text-xs font-medium rounded" }, " Istekao ", -1))
                          ]))
                        }), 128))
                      ]),
                      _createVNode(_component_PaginationComponent, {
                        meta: _ctx.inactiveMeta,
                        "current-page": _ctx.inactiveCurrentPage,
                        "update-url": true,
                        onPageChange: _ctx.handleInactivePageChange
                      }, null, 8, ["meta", "current-page", "onPageChange"])
                    ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ConfirmationModal, {
      show: _ctx.deleteModal.show,
      title: _ctx.deleteModal.title,
      message: _ctx.deleteModal.message,
      type: "danger",
      "confirm-text": "Obriši",
      "is-loading": _ctx.deleteModal.isLoading,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteModal.show = false)),
      onConfirm: _ctx.confirmDelete
    }, null, 8, ["show", "title", "message", "is-loading", "onConfirm"]),
    _createVNode(_component_ConfirmationModal, {
      show: _ctx.renewModal.show,
      title: _ctx.renewModal.title,
      message: _ctx.renewModal.message,
      type: "success",
      "confirm-text": "Obnovi",
      "is-loading": _ctx.renewModal.isLoading,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.renewModal.show = false)),
      onConfirm: _ctx.confirmRenew
    }, null, 8, ["show", "title", "message", "is-loading", "onConfirm"]),
    _createVNode(_component_ToastNotification, {
      show: _ctx.toast.show,
      message: _ctx.toast.message,
      type: _ctx.toast.type,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toast.show = false))
    }, null, 8, ["show", "message", "type"])
  ]))
}